import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Shimmer } from '../../../../ui';
import { Tile } from '../../../../ui/new-components/Tile';
import Responsive from '../../../../ui/utils/Responsive';
import { StyledSection } from '../../../account/ui/account-overview/AccountShortcutsSection';
import { useUserStore } from '../../../auth/user/domain/stores/useUserStore';
import { StyledFlexShortcutItem } from '../../../home/ui/shortcuts/StyledFlexShortcutGrid';
import { StyledShortcutDiv } from '../../../home/ui/shortcuts/StyledShortcut';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { useNewsroomShortcuts } from '../../domain/hooks/useNewsroomShortcuts';

export const NewsShortcutsSection = observer(() => {
	const { t } = useTranslation();
	const { shortcuts } = useNewsroomShortcuts();
	const { isLoading } = useUserStore();

	const [hasHydrated, setHasHydrated] = useState(false);

	useEffect(() => {
		setHasHydrated(true);
	}, []);

	if (!hasHydrated) {
		return null;
	}

	if (isLoading) {
		return (
			<StyledSection>
				<StyledShortcutsContentWrap>
					<Shimmer aria-label={t('shimmer_aria_label')} style={{ flexGrow: 1 }}>
						<StyledShortcutDiv />
					</Shimmer>
				</StyledShortcutsContentWrap>
			</StyledSection>
		);
	}
	return (
		<StyledSection>
			<StyledShortcutsContentWrap role="list">
				{shortcuts.map((shortcut) => (
					<StyledFlexShortcutItem
						key={shortcut.title}
						number={shortcuts.length}
						role="listitem"
					>
						<Tile {...shortcut} />
					</StyledFlexShortcutItem>
				))}
			</StyledShortcutsContentWrap>
		</StyledSection>
	);
});

const StyledShortcutsContentWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 24px;
	padding-left: 0px;
	margin-top: -140px; // needed so that the entry points fall on top of this section

	> div {
		margin-left: 0;
		margin-top: 0;
		flex-grow: 1;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-top: inherit;
		gap: 8px;
	}
`;
